<div class="dialog">
  <div class="cancel-form-wrapper">
    <form class="cancel-form">
      <h3 class="cancel-form__header">{{ 'ADF_PROCESS_LIST.CANCEL_PROCESS.TITLE' | translate }}</h3>
      <p class="cancel-form__description">
        {{ 'ADF_PROCESS_LIST.CANCEL_PROCESS.DESCRIPTION' | translate }} {{ processTemplateName }}
      </p>
      <div>
        <span class="cancel-reason">{{ 'ADF_PROCESS_LIST.CANCEL_PROCESS.REASON' | translate }}</span>
        <mat-form-field appearance="outline">
          <textarea
            matInput
            [placeholder]="'ADF_PROCESS_LIST.CANCEL_PROCESS.PLACEHOLDER' | translate"
            class="cancel-reason-input"
            [(ngModel)]="cancellationReason"
            name="cancel-reason"
          ></textarea>
        </mat-form-field>
      </div>
      <button mat-icon-button class="close-icon" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </form>
    <div class="cancel-form__actions">
      <button
        type="button"
        class="wk-button wk-button-text close-button"
        (click)="close()"
      >
        <span class="close-label">{{ 'APP.ACTIONS.CLOSE' | translate }}</span>
      </button>
      <button type="button" class="wk-button" (click)="cancelProcess()">
        <span class="confirm-label">{{ 'APP.COMMON.CONFIRM' | translate }}</span>
      </button>
    </div>
  </div>
  <div class="attachments-form">
    <h3 class="attachments-form__header">{{ 'ADF_TASK_LIST.DETAILS.LABELS.ATTACHMENTS' | translate }}</h3>
    <div class="loading-spinner" *ngIf="isLoading">
      <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
    </div>
    <div class="attachments-list" *ngIf="!isLoading">
      <div
        class="attachment-cell"
        *ngFor="let attachment of checkedoutAttachments"
      >
        <ng-container *ngIf="attachment.checkedout;else attachFile">
          <mat-icon
            title="File checked out by {{ attachment.checkedoutOwner.displayName }}"
            class="lock-icon"
            >lock_outline</mat-icon
          >
          <a
            class="attachment-name"
            title="File checked out by {{ attachment.checkedoutOwner.displayName }}"
          >
            {{ attachment.attachmentName }}
          </a>
        </ng-container>
        <ng-template #attachFile>
          <mat-icon [title]="attachment.attachmentName" class="attach-file-icon"
            >attach_file</mat-icon
          >
          <a class="attachment-name" [title]="attachment.attachmentName">
            {{ attachment.attachmentName }}
          </a>
        </ng-template>
      </div>
    </div>
  </div>
</div>
